import { Link } from '@reach/router';
import { AppPath, DashboardPath } from 'appConstants';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectAuthStatus } from 'reducers/auth';
import { selectAccountTypePathItem } from 'reducers/componentResources';
import { selectCultureCode } from '../../reducers/language';
import { FooterLikItem, FooterLinks } from './types';
import { useTranslation } from 'react-i18next';

type FooterProps = {
    links: FooterLinks;
};

const Footer: React.FC<FooterProps> = ({ links }) => {
    const cultureCode = useSelector(selectCultureCode);
    const isLoggedIn = useSelector(selectAuthStatus) === 'signed_in';
    const accountTypePathItem = useSelector(selectAccountTypePathItem);
    const { t, i18n } = useTranslation('common');
    return (
        <>
            <div className="Footer Desktop">
                <ul>
                    {links &&
                        links.map((l: FooterLikItem, i: number) => {
                            const path = `/${cultureCode}${
                                isLoggedIn
                                    ? `${accountTypePathItem}${DashboardPath.INFO}`
                                    : AppPath.INFO
                            }${l.url}`;
                            const footerKey = `footer_${l.title}`;
                            const hasTranslation = i18n.exists(footerKey);
                            const title = hasTranslation ? t(footerKey) : l.title;
                            return (
                                <li key={l.id}>
                                    <Link
                                        to={path}
                                        className={hasTranslation ? 'notranslate' : undefined}
                                        translate={hasTranslation ? 'no' : undefined}
                                    >
                                        {title}
                                    </Link>
                                </li>
                            );
                        })}
                </ul>
            </div>
        </>
    );
};

export default Footer;
